import { Button, SuggestionSelect } from '@descomplica/foundation-ui-components';
import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Input } from '@/shared/presentation/components/ui/Input';
import { Page } from '@/shared/presentation/components/ui/Page';

import { CreateSSORegistrationViewModel } from './CreateSSORegistration.vm';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 8px;
`;

const ConfirmButton = styled(Button)`
  align-self: end;
`;

const CreateSSORegistrationForm = observer(() => {
  const vm = useViewModel(CreateSSORegistrationViewModel);

  return (
    <Form>
      <SuggestionSelect
        label="Provedor"
        placeholder="Definir provedor"
        onChange={(value) => {
          vm.form.setValueAndValidateValue('provider', value?.guid);
        }}
        value={vm.form.values.provider}
        availableOptions={vm.providers.map((provider) => ({
          guid: provider.slug,
          name: provider.name,
        }))}
      />
      <SuggestionSelect
        label="Escopo"
        placeholder="Definir escopo"
        onChange={(value) => {
          vm.form.setValueAndValidateValue('scope', value);
        }}
        value={vm.form.values.scope}
        availableOptions={vm.scopes.map((scope) => ({
          guid: scope.guid,
          name: scope.name,
        }))}
      />
      <SuggestionSelect
        label="Papel"
        placeholder="Definir papel"
        onChange={(value) => {
          vm.form.setValueAndValidateValue('role', value);
        }}
        value={vm.form.values.role}
        availableOptions={vm.roles.map((role) => ({
          guid: role.guid,
          name: role.name,
        }))}
      />
      <Input
        label="Tag"
        name="tag"
        errorMessage={vm.form.errors.tag && vm.form.errors.tag[0]}
        onChange={(value) => vm.form.setValue('tag', value)}
        onBlur={() => vm.form.validateField('tag')}
        value={vm.form.values.tag}
      />
    </Form>
  );
});

export const CreateSSOScreen = observer(() => {
  const navigate = useNavigate();
  const vm = useViewModel(CreateSSORegistrationViewModel, { navigate });

  const onCreateClick = async () => {
    await vm.create();
  };

  return (
    <Page
      title="SSO"
      subtitle="Crie url de cadastro para os provedores de SSO"
      isLoading={vm.isLoading}
      hasError={vm.hasError}
    >
      <Container>
        <CreateSSORegistrationForm />
        <ConfirmButton
          disabled={
            vm.form.values.role == null ||
            vm.form.values.provider == null ||
            vm.form.values.scope == null
          }
          onClick={onCreateClick}
          size="small"
        >
          Gerar url de cadastro
        </ConfirmButton>
      </Container>
    </Page>
  );
});
